module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductDetailImages":{"nextImage":"Další obrázek","previousImage":"Předchozí obrázek","selectImage":"Zobrazit obrázek {index}"}}}')
  delete Component.options._Ctor
}
